import React from 'react';
import RelaxationSidebar from './RelaxationSidebar';
import { Outlet } from 'react-router-dom';
import Navbar from '../../component/Navbar';
import Footer from '../../component/Footer';

function RelaxationLayout() {
  return (
    <>
      <Navbar />
      <div className='flex'>
        <div className='w-[20%]'>
          <RelaxationSidebar />
        </div>
        <div className='w-[80%]'>
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RelaxationLayout;
